var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVandewieleB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 239.8913537 31.7057326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.8476604,20.0096282c1.1687436,3.9167222,4.1500244,7.0325962,8.0084009,8.376303l.5944727.2041361V5.8120886L.7893415,19.8167094l.0583188.1929188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.3228859,6.3572001l-.5944727-.2063822v22.7869498l8.6051197-14.0135919-.0560861-.1906727c-1.150788-3.9077511-4.1118804-7.0236251-7.9545608-8.376303Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.5749474,20.7966257l.7050781,2.6855469.6713867-2.6855469,5.3037109-14.9716797h5.4384766l-8.3925781,22.8271484h-6.3442383L27.5642052,5.824946h5.7070312l5.3037109,14.9716797Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.7521935,24.3889108h-8.9633789l-1.5102539,4.2631836h-5.4047852l8.3251953-22.8271484h6.4453125l8.3588867,22.8271484h-5.7407227l-1.5102539-4.2631836ZM56.2663537,20.2595163h6.0087891l-2.3164062-6.5791016-.6713867-2.5849609-.7050781,2.5849609-2.315918,6.5791016Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.1184045,5.824946h5.6733398l7.2172852,11.984375,1.7456055,3.6254883-.2685547-15.6098633h5.3710938v22.8271484h-5.6733398l-7.2172852-11.984375-1.7456055-3.6591797.2685547,15.6435547h-5.3710938V5.824946Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.7849084,5.824946h8.7617188c7.2172852,0,11.715332,4.3305664,11.715332,11.4472656s-4.4980469,11.3798828-11.715332,11.3798828h-8.7617188V5.824946ZM111.7565881,17.2722116c0-4.4648438-2.2827148-7.0830078-6.2099609-7.0830078h-3.390625v14.0986328h3.390625c3.9272461,0,6.2099609-2.5844727,6.2099609-7.015625Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.4514123,5.824946h16.3818359v4.2631836h-11.0107422v4.800293h9.7016602v4.1630859h-9.7016602v5.3374023h11.0107422v4.2631836h-16.3818359V5.824946Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.2360802,15.5266061l-.5371094-2.4169922-.5708008,2.4169922-3.6928711,13.1254883h-6.0419922l-6.7475586-22.8271484h5.7402344l3.6591797,14.9716797.6040039,2.7192383.6044922-2.7192383,4.2294922-14.9716797h4.699707l4.1962891,14.9716797.6040039,2.7192383.6044922-2.7192383,3.6591797-14.9716797h5.4379883l-6.7475586,22.8271484h-5.9750977l-3.7260742-13.1254883Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.2702599,5.824946h5.3710938v22.8271484h-5.3710938V5.824946Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.5690881,5.824946h16.3818359v4.2631836h-11.0107422v4.800293h9.7011719v4.1630859h-9.7011719v5.3374023h11.0107422v4.2631836h-16.3818359V5.824946Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.1061974,5.824946h5.3710938v18.4628906h10.0371094v4.3642578h-15.4082031V5.824946Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.2341271,5.824946h16.3818359v4.2631836h-11.0107422v4.800293h9.7011719v4.1630859h-9.7011719v5.3374023h11.0107422v4.2631836h-16.3818359V5.824946Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVandewieleB);
export default __webpack_public_path__ + "static/media/logo_vandewiele_b.ade57759ad58f04aaca283e18c86c379.svg";
export { ForwardRef as ReactComponent };